import React from "react";
import { ShieldCheck } from "lucide-react";
import Reveal from "../Reveal";
import { useContent } from "../../context/ContentContext";

export default function Certifications() {
  const { content } = useContent();
  const certifications = content.certifications || [];
  const row = [...certifications, ...certifications];
  return (
    <section className="py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.2em] text-[#2ED9B8] font-medium">Global certifications</p>
          <h2 className="mt-3 font-display text-[34px] lg:text-[44px] leading-[1.08] text-foreground">
            Partners with global accreditations
          </h2>
          <p className="mt-4 text-[15.5px] text-muted-foreground">
            Our manufacturing partners hold accreditations across major regulatory bodies worldwide.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 marquee-mask overflow-hidden">
        <div className="flex gap-4 w-max animate-marquee">
          {row.map((c, i) => (
            <div
              key={`${c}-${i}`}
              className="flex items-center gap-2.5 shrink-0 bg-card border border-white/10 rounded-full pl-3 pr-5 py-3 shadow-[0_10px_30px_-24px_rgba(12,97,82,0.6)]"
            >
              <span className="h-8 w-8 rounded-full bg-[#0f2236] flex items-center justify-center">
                <ShieldCheck className="h-4 w-4 text-[#2ED9B8]" />
              </span>
              <span className="text-sm font-medium text-foreground whitespace-nowrap">{c}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
